import type { IMetricViewFilters } from '@/hooks/use-metric-view-filters';
import { CodeQualityShell } from './code-quality/CodeQualityShell';

interface CodeQualityTabProps {
  filters: IMetricViewFilters;
}

/**
 * Code Quality tab — entry point referenced by `MetricViewTabs`. Delegates to
 * `CodeQualityShell` which owns the page-level fetch + slot composition.
 *
 * Spec: specs/metric-view-code-quality/
 */
export function CodeQualityTab({ filters }: Readonly<CodeQualityTabProps>) {
  return <CodeQualityShell filters={filters} />;
}
